// Кривая мощности: лучшая средняя мощность, которую гонщик удержал на каждой
// длительности. С бэкенда приходит массивом [[секунды, ватты, вт/кг], ...]
// по возрастанию длительности — см. PowerCurveService.

export const POWER_UNITS = ['watts', 'wkg'];

// Подпись длительности: до минуты в секундах, дальше в минутах, час отдельно
export const formatCurveDuration = (seconds, t) => {
  const value = Number(seconds);
  if (!Number.isFinite(value) || value <= 0) return '';

  if (value < 60) return `${value}${t('power_curve.unit_seconds')}`;
  if (value < 3600) return `${Math.round(value / 60)}${t('power_curve.unit_minutes')}`;

  const hours = value / 3600;
  return `${Number.isInteger(hours) ? hours : hours.toFixed(1)}${t('power_curve.unit_hours')}`;
};

// Значение точки в выбранных единицах. В W/kg точка может отсутствовать —
// вес пишет в FIT не каждое приложение
export const pointValue = (point, unit) => {
  if (!point) return null;

  const value = unit === 'wkg' ? point[2] : point[1];
  return Number.isFinite(value) ? value : null;
};

export const formatPowerValue = (value, unit) => {
  if (value === null || value === undefined) return '—';

  return unit === 'wkg' ? value.toFixed(2) : Math.round(value);
};

// Точки, у которых есть значение в выбранных единицах
export const usableSeries = (series, unit) =>
  (series || []).filter(point => pointValue(point, unit) !== null);

// Есть ли вообще W/kg — если нет, переключатель единиц показывать нечего
export const hasWkg = (...seriesList) =>
  seriesList.some(series => usableSeries(series, 'wkg').length > 0);
